import services from '@/config/services'

let availabilityRequest = null

export default class CambioRappresentanteService {
  constructor(http) { this.http = http }
  async isAvailable() {
    if (!availabilityRequest) {
      availabilityRequest = this.http.get(`${services.ask_pratiche.url}/clienti/cambio-rappresentante/available`)
        .then(response => response.data.available === true)
        .finally(() => { availabilityRequest = null })
    }
    return availabilityRequest
  }
  async preview(clientIds) {
    const response = await this.http.post(`${services.ask_pratiche.url}/clienti/cambio-rappresentante/preview`, { clienti_ids: clientIds })
    return response.data
  }
  async search(payload) {
    return (await this.http.post(`${services.ask_pratiche.url}/multisito/check-exist-rapp`, payload)).data
  }
  async options() {
    const [toponimi, comuni] = await Promise.all([
      this.http.get(`${services.ask_pratiche.url}/get-toponimi`),
      this.http.get(`${services.ask_pratiche.url}/get-cities-rapp`)
    ])
    return { toponimi: toponimi.data, comuni: comuni.data }
  }
  async save(payload) {
    return (await this.http.post(`${services.ask_pratiche.url}/clienti/cambio-rappresentante`, payload)).data
  }
  async createRepresentative(payload) {
    return (await this.http.post(`${services.ask_pratiche.url}/rappresentanti/crea`, payload)).data
  }
  async searchClients(query, representativeId) {
    const response = await this.http.get(`${services.ask_pratiche.url}/clienti/cambio-rappresentante/search`, { params: { query, rappresentante_id: representativeId } })
    return response.data || []
  }
  async storicoCambiRappresentante(clienteId) {
    const response = await this.http.get(`${services.ask_pratiche.url}/clienti/${clienteId}/storico-cambi-rappresentante`)
    return response.data || []
  }
  async storicoCambiContatto(contrattoId) {
    const response = await this.http.get(`${services.ask_pratiche.url}/contratti/${contrattoId}/storico-cambi-contatto`)
    return response.data || []
  }
}
